import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/index.vue";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
        meta: { name: "home" }
      },
      {
        path: "/mall",
        name: "mall",
        component: () => import("../views/mall/index.vue"),
        meta: { name: "mall" }
      },
      {
        path: "/alliance",
        name: "alliance",
        component: () => import("../views/alliance/index.vue"),
        meta: { name: "alliance" }
      },
      {
        path: "/me",
        name: "me",
        component: () => import("../views/me/index.vue"),
        meta: { name: "me" }
      },
    ],
  },
];

// 保存原始方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理重复路由跳转的错误
    if (err.name !== 'NavigationDuplicated') {
      // 如果不是重复跳转错误，将错误继续抛出
      throw err;
    }
  });
};

// 重写 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach(() => {
  // 平滑滚动到顶部（兼容大部分浏览器）
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router;
